"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = require("@apollo/client");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var GameStateLoaded_1 = require("../../Actions/GameStateLoaded");
var GameClientAPI_1 = require("./GameClientAPI");
var GameNotificationsListener_1 = __importDefault(require("./GameNotificationsListener"));
var GET_GAME = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query Game($id: String!) {\n    time\n    game(id: $id) {\n      id\n      players {\n        id userId name avatar {...AvatarInfo} gamePointsDelta tournamentPoints ...PlayerTime\n      }\n      options {\n        speed maxSpareTime maxExceedTime\n      }\n      notificationsChannel notificationsCount mode setup state myPlayerId endDate\n      tournament {\n        number signedUp\n      }\n    }\n  } ", " ", "\n"], ["\n  query Game($id: String!) {\n    time\n    game(id: $id) {\n      id\n      players {\n        id userId name avatar {...AvatarInfo} gamePointsDelta tournamentPoints ...PlayerTime\n      }\n      options {\n        speed maxSpareTime maxExceedTime\n      }\n      notificationsChannel notificationsCount mode setup state myPlayerId endDate\n      tournament {\n        number signedUp\n      }\n    }\n  } ", " ", "\n"])), GameClientAPI_1.PLAYERS_TIME, GameClientAPI_1.AVATAR_INFO);
function RemoteGameLoader(_a) {
    var _b;
    var gameId = _a.gameId;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, client_1.useLazyQuery)(GET_GAME), getGame = _c[0], data = _c[1].data;
    (0, react_1.useEffect)(function () {
        getGame({ variables: { id: gameId } }).then(function (result) {
            if (result.data) {
                dispatch((0, GameStateLoaded_1.gameStateLoaded)(result.data.game, result.data.time));
            }
        });
    }, []);
    if (!data)
        return null;
    else
        return (0, jsx_runtime_1.jsx)(GameNotificationsListener_1.default, { channelName: (_b = data.game.notificationsChannel) !== null && _b !== void 0 ? _b : "game=".concat(gameId), gameId: gameId });
}
exports.default = RemoteGameLoader;
var templateObject_1;
